import { render } from "./HeroiconsSolidSun.vue?vue&type=template&id=494cd818"
const script = {}

import exportComponent from "/var/www/doughcoteam.co.uk/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidSun.vue"]])

export default __exports__